<template>
  <div id="StoreSelect" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
        <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
          <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>omercio</div>
          <div class="col-3 t-r f22 pr3"></div>
        </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(pos, pos_i) in data_list" v-bind:key="pos_i" @click="get_store(pos.appid)">
        <div class="col-12 bg-color-white pt10 pb10 pl10 pr10">
            <div class="col-2">
              <img src="@/assets/store_logo.png"  class="w5"> 
            </div>
            <div class="col-10 pl10 pt5">
              <div class="col-12 f14 uppercase color-muted">{{ pos.license_type }}-{{ pos.license }} <span class="color-black f12" v-if="pos.store > 1">[ Sucursal {{ pos.store }} ]</span></div>
              <div class="col-12 f14 fw uppercase el1 pt5"><i class="iconfont icon-cloud-link-full color-success" v-if="pos.is_online > 0"></i><i class="iconfont icon-cloud-link-full color-muted" v-else></i> {{ pos.enterprise_name }}</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StoreSelect',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.user_type = this.$route.query.user_type;
      this.post(this.api_url + 'manage/store_select', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.store;
        }else{
          this.data_list = []
        }
      })
    },
    //选择商户
    get_store(appid) {
      var post_data = {};
      post_data.appid = appid;
      this.post(this.api_url + 'manage/store_changer', post_data).then((res)=>{
        if(res.status == 1){
          this.$router.push({ path: '/Main' });
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/StoreSelect.vue